var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _path11, _rect3, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGibraltarFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -3,
    width: 32,
    height: 24,
    fill: "#F7FCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 13H28V21H-4V13Z",
    fill: "#C51918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.0771H3V12.1543H20V13.0771ZM13.3887 6.61523H14.334V3.8457H18.1113V6.61523H20V7.53906H19.0557V12.1533H3.94434V7.53906H3V6.61523H4.88867V3.8457H8.66602V6.61523H9.61133V2H13.3887V6.61523Z",
    fill: "#DB000B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 5.58873C5.8335 5.13576 6.2007 4.76855 6.65367 4.76855C7.10664 4.76855 7.47385 5.13576 7.47385 5.58873V6.79932H5.8335V5.58873Z",
    fill: "#272727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2778 5.58873C15.2778 5.13576 15.645 4.76855 16.098 4.76855C16.551 4.76855 16.9182 5.13576 16.9182 5.58873V6.79932H15.2778V5.58873Z",
    fill: "#272727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56738 10.4709C5.56738 9.87103 6.05365 9.38477 6.65349 9.38477C7.25334 9.38477 7.7396 9.87103 7.7396 10.4709V12.3386H5.56738V10.4709Z",
    fill: "#272727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0117 10.4709C15.0117 9.87103 15.498 9.38477 16.0978 9.38477C16.6977 9.38477 17.1839 9.87103 17.1839 10.4709V12.3386H15.0117V10.4709Z",
    fill: "#272727"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89453 10.6389C9.89453 9.87021 10.5177 9.24707 11.2863 9.24707C12.055 9.24707 12.6782 9.87021 12.6782 10.6389V13.3086H9.89453V10.6389Z",
    fill: "#272727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5557 4.66588C10.5557 4.21291 10.9229 3.8457 11.3758 3.8457C11.8288 3.8457 12.196 4.21291 12.196 4.66588V6.79955H10.5557V4.66588Z",
    fill: "#272727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.69238,
    width: 0.944444,
    height: 0.923077,
    fill: "#DE1A23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4H4.5V3H5.5V4ZM7.75 4H6.25V3H7.75V4ZM9.31836 4H8.31836V3H9.31836V4Z",
    fill: "#DE1A23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0908 4H14.0908V3H15.0908V4ZM17.2041 4H15.7041V3H17.2041V4ZM18.8184 4H17.8184V3H18.8184V4Z",
    fill: "#DE1A23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 2.02246H8.7998V1.02246H9.7998V2.02246ZM11.2998 2.02246H10.2998V1.02246H11.2998V2.02246ZM12.7998 2.02246H11.7998V1.02246H12.7998V2.02246ZM14.2998 2.02246H13.2998V1.02246H14.2998V2.02246Z",
    fill: "#DE1A23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9995,
    y: 5.77441,
    width: 1,
    height: 0.838696,
    fill: "#DE1A23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1528 13.6787L11.4399 15.4521L8.36377 13.9893L11.2583 12.3252L14.1528 13.6787ZM10.3804 13.8408L11.3628 14.3086L12.2056 13.7568L11.2681 13.2461L10.3804 13.8408Z",
    fill: "#E8AA00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8159 15.1133H12.0667V19.1133H10.8159V15.1133Z",
    fill: "#E8AA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGibraltarFlagIcon);
export default __webpack_public_path__ + "static/media/gibraltarFlagIcon.375ae1af11996d5980775bf3c3c79c2f.svg";
export { ForwardRef as ReactComponent };